import { useState } from 'react';
import { Link } from "react-router-dom";
import Logo1 from '../../../images/logo.png'
import Logo2 from '../../../images/logo.jpg'

export default function SignUp() {
    // States for registration
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    // States for checking the errors
    const [submitted, setSubmitted] = useState(false);
    const [error, setError] = useState(false);
    const [errorPassword, setPasswordError] = useState("");

    // Handling the form submission
    const handleSubmit = (event) => {
        event.preventDefault();
        if (email === '' || password === '' || confirmPassword === '') {
            setError(true);
        } 
        else {
            if( password === confirmPassword){
                setSubmitted(true);
                setError(false);
            }else{
                setPasswordError("Les mots de passe ne correspondent pas");
            }
        }
    };

    return (
      <div className='bg-white h-screen'>
        <div className="grid grid-cols-2 h-full">
        <div className='bg-black hidden lg:flex'>
            <img src={Logo2} className='h-full' alt=''/>
        </div>
        <div className="flex bg-white col-span-2 lg:col-span-1 min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8">
          <div className="sm:mx-auto sm:w-full sm:max-w-sm">
            <img
              className="mx-auto h-10 w-auto flex lg:hidden"
              src={Logo1}
              alt="Rokasa Collection"
            />
            <h2 className="mt-5 lg:mt-0 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">
              Créer un compte
            </h2>
          </div>
  
          <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm ">
              <form className="space-y-4 md:space-y-6" onSubmit={handleSubmit}>
                  <div>
                      <label for="email" className="block mb-2 text-sm font-medium text-gray-900 ">E-mail</label>
                      <input 
                        type="email"
                        name="email"
                        value={email} onChange={(e) => setEmail(e.target.value)} 
                        className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-gray-600 focus:border-gray-600 block w-full p-2.5 " 
                        placeholder="nom@gmail.com" 
                        required
                        />
                  </div>
                  <div>
                      <label for="password" className="block mb-2 text-sm font-medium text-gray-900 ">Mot de passe</label>
                      <input 
                        type="password" 
                        name="password" 
                        value={password} onChange={(e) => setPassword(e.target.value)}
                        placeholder="••••••••" 
                        minLength={8}
                        // pattern='/(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/'
                        className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-gray-600 focus:border-gray-600 block w-full p-2.5 " 
                        required
                        />
                        <p className="text-red-500 text-xs italic mt-2">
                        Le mot de passe doit comporter au moins 8 caractères
                      </p>
                  </div>
                  <div>
                      <label for="confirm-password" className="block mb-2 text-sm font-medium text-gray-900 ">Confirmez le mot de passe</label>
                      <input 
                        type="password" 
                        name="confirm-password" 
                        value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} 
                        placeholder="••••••••" 
                        minLength={8}
                        // pattern='/(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/'
                        className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-gray-600 block w-full p-2.5 " 
                        required
                        />
                  </div>
                  {errorPassword && <p className='text-red-600 px-2 text-sm sm:col-span-full'>* {errorPassword}</p>}
                  <div className="flex items-start">
                      <div className="flex items-center h-5">
                        <input id="terms" aria-describedby="terms" type="checkbox" class="w-4 h-4 border text-black border-gray-300 rounded bg-gray-50 focus:ring-3 focus:ring-gray-300  " required=""/>
                      </div>
                      <div class="ml-3 text-sm">
                        <label for="terms" className=" text-gray-500">J'accepte les  <a class="font-medium text-gray-600 hover:underline" href="#">Conditions générales</a></label>
                      </div>
                  </div>
                  <button 
                        type="submit"
                        className="w-full text-white bg-black hover:bg-gray-700 focus:ring-4 focus:outline-none focus:ring-gray-900 font-medium rounded-lg text-sm px-5 py-2.5 text-center ">
                        Créer un compte
                  </button>
                  <p className="text-sm text-gray-500 text-center">
                  Vous avez déjà un compte ? <Link to="/sign-in" className="font-medium text-black hover:text-gray-900">Connectez-vous</Link>
                  </p>
              </form>
          </div>
        </div>
        </div>
      </div>
    )
  }
  